import { createFileRoute, redirect } from '@tanstack/react-router'
import { withRoutePermissions } from '~/utils/rbac'

/**
 * `/industrial-configurator` — écran masqué en attendant sa refonte : les cuisines des prévisions
 * se lisent désormais sur `store_product_central_kitchens`, que l'écran ne sait pas encore éditer.
 * La route redirige plutôt que de disparaître pour ne casser ni favoris ni liens partagés ; l'API
 * du configurateur reste servie (le simulateur logistique la lit).
 */
export const Route = createFileRoute('/_authenticated/industrial-configurator')({
  staticData: {
    permission: ['read', 'previsions.industrial-configurator.kitchen'],
  },
  beforeLoad: () => {
    throw redirect({ to: '/previsions', search: { capping: true } })
  },
})

withRoutePermissions(Route)
